import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SidebarComponent from '../common/sidebar-component';
import WireResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import StockCode from '../common/sidebar/stock-code';
import useGetStockCodesFromWires from '../../../services/stock-codes/from-wires-service';

export default function TopStockCodes({ titleMatchedWires }) {
  const { dispatch } = React.useContext(WireResultsContext);
  const wireIDs = _.map(titleMatchedWires, 'id');
  const [{ data }, executeQuery] = useGetStockCodesFromWires(wireIDs, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'stock_codes.length')) {
      dispatch({ type: 'setStockCodes', payload: data.stock_codes });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'stock_codes.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.stock_codes.length > 1 ? 'companies' : 'company'} mentioned in`}
        query={titleMatchedWires[0].title}
      />
      {data.stock_codes.map(d => <StockCode key={`stock-code-${d.id}`} stockCode={d} />)}
    </SidebarComponent>
  );
}

TopStockCodes.propTypes = {
  titleMatchedWires: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
};
